import api from "api";
import secureLocalStorage from "react-secure-storage";

export function getEngagements(sd,ed) {  
  return api.get(`engagementSchedule/${secureLocalStorage.getItem('id')}?start=${sd}&end=${ed}`);
}

